import React from 'react'
import Stores from '../components/Stores';
import SideBar from '../components/SideBar';
import Header from '../components/Header';

const StorePage = () => {
    return (
        <>
        <SideBar />
        <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
            <Header title="Stores" />
            
            <Stores />
            
        </main>
        </>
        
    );
    };

export default StorePage